import * as ambassadorWixBookingsProvisionerV1AppsCloned from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.http.js';
import * as ambassadorWixBookingsProvisionerV1AppsClonedTypes from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.types.js';
import * as ambassadorWixBookingsProvisionerV1AppsClonedUniversalTypes from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function provisionBookingsPlatform(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsProvisionerV1AppsClonedUniversalTypes.ProvisionBookingsPlatformRequest,
  ambassadorWixBookingsProvisionerV1AppsClonedTypes.ProvisionBookingsPlatformRequest,
  ambassadorWixBookingsProvisionerV1AppsClonedUniversalTypes.ProvisionBookingsPlatformResponse,
  ambassadorWixBookingsProvisionerV1AppsClonedTypes.ProvisionBookingsPlatformResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsProvisionerV1AppsCloned.provisionBookingsPlatform(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/provisioner/provision-bookings-platform',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AppsClonedFromTemplate as AppsClonedFromTemplateOriginal,
  App as AppOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  CreateBusinessScheduleRequest as CreateBusinessScheduleRequestOriginal,
  CreateBusinessScheduleResponse as CreateBusinessScheduleResponseOriginal,
  ProvisionBookingsPlatformRequest as ProvisionBookingsPlatformRequestOriginal,
  TimeSlotsConfiguration as TimeSlotsConfigurationOriginal,
  DisplayTimeZone as DisplayTimeZoneOriginal,
  BasedOn as BasedOnOriginal,
  BasedOnWithLiterals as BasedOnWithLiteralsOriginal,
  StaffSelection as StaffSelectionOriginal,
  Strategy as StrategyOriginal,
  StrategyWithLiterals as StrategyWithLiteralsOriginal,
  SplitInterval as SplitIntervalOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ProvisionBookingsPlatformResponse as ProvisionBookingsPlatformResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './bookings-provisioner-v1-apps-cloned-bookings-provisioner.types.js';
